import { NativeModules } from "react-native";

export type JobCardNativeModule = Partial<{
  dislikeJob(jobKey: string, pageId: string, undo: boolean, tk: string | null): Promise<void>;
  logJobClick(clickUrl: string): Promise<void>;
}>;

/**
 * Entry point for accessing the native module
 *
 * Do not access the react-native NativeModules object directly outside of this method.
 *
 * CAUTION: This is fake type-safety. It assumes the native modules are defined correctly.
 */
export function jobCardNativeModule() {
  return NativeModules.JobCardNativeModule as JobCardNativeModule | null | undefined;
}
